export enum OptimoveEventName {
    ClickOnSymbol = "click_on_symbol",
    ClickOnNews = "click_on_news",
    ClickOnEconomicCalendar = "click_on_economic_calendar",
    ClickOnSignals = "click_on_signals",
    ClickOnAcademy = "click_on_academy",
    ClickOnMyAccount = "click_on_my_account",
    DepositAttempt = "deposit_attempt",
    DepositIncomplete = "deposit_incomplete",
    ClickOnNotifications = "click_on_notifications",
    ClickOnAvailableFeatures = "click_on_available_features",
    SessionStart = "session_start"
}
